export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* YouTube背景動画 */}
      <div className="absolute inset-0 w-full h-full">
        <iframe
          className="absolute top-1/2 left-1/2 w-[100vw] h-[56.25vw] min-h-[100vh] min-w-[177.77vh] -translate-x-1/2 -translate-y-1/2"
          src="https://www.youtube.com/embed/tzW4LsQANzI?autoplay=1&mute=1&loop=1&playlist=tzW4LsQANzI&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
          title="Background video"
          allow="autoplay; encrypted-media"
          style={{ pointerEvents: 'none' }}
        />
      </div>

      {/* オーバーレイ */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 text-center px-6">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-8 tracking-tight">
          <div className="mb-2">Craft Wonder</div>
          <div>& Spark Joy.</div>
        </h1>
        <p className="text-xl md:text-2xl text-white/90 font-light">
          The Entertainment Design Company
        </p>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 flex flex-col items-center">
        <span className="text-white text-xs tracking-widest mb-4">SCROLL</span>
        <div className="w-px h-16 bg-white/40 animate-pulse"></div>
      </div>
    </section>
  );
}
